// extracted by mini-css-extract-plugin
module.exports = {"component":"Message_component__2EGxi","innerCover":"Message_innerCover__QJ9ui","highBold":"Message_highBold__1rfhI"};